
import Vue from 'vue'

export default Vue.extend({
    name: 'Hero',
    components: {
    },
    computed: {
        typeFormUrl() {
            return process.env.VUE_APP_TYPEFORM_URL;
        }
    },
    data(){
        return{
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            valid: false,
        }
    },
    methods: {
    },
    mounted() {
    }
})
